export const isNonprofitDBId = (maybeNonprofitDBId?: string) =>
  /^[a-z0-9]{10}$/.test(maybeNonprofitDBId || '');
